export const Menu: any = {
  'Product Health': [
    { name: 'Product Metrics', icon: 'bar_chart', path: '/product-metrics',
      children: [
        {
          name: 'Current Product Metrics',
          icon: 'bar_chart',
          path: '/product-metrics', "pdfkey": "product-metrix"
        },
        {
          name: 'Historical Product Metrics',
          icon: 'query_stats',
          path: '/historical-product-metrics', "pdfkey": "product-metrix"
        },
      ],
      "pdfkey": "product-metrix" },
    {
      name: 'Simulate',
      icon: 'trending_up',
      path: '/simulate',
      children: [
        { name: 'Basic Simulation', icon: 'timeline', path: '/simulate', "pdfkey": "product-metrix" },
        { name: 'Advanced Simulation', icon: 'science', path: '/simulate2', "pdfkey": "product-metrix" },
      ],
      "pdfkey": "product-metrix"
    },
    { name: 'Surveys', icon: 'list_alt', path: '/survey', dynamicChildren: 'openSurveyTypes', "pdfkey": "product-metrix" },
    {
      name: 'Survey Records & Audits',
      icon: 'fact_check',
      path: '/survey-records-audits',
      children: [
        { name: 'Data Entry', icon: 'fact_check', path: '/survey-records-audits', "pdfkey": "product-metrix" },
        { name: 'PM Rollup', icon: 'analytics', path: '/survey-records-audits-pm-rollup', "pdfkey": "product-metrix" },
      ],
      "pdfkey": "product-metrix"
    },
    { name: 'Audit Survey', icon: 'check_circle', path: '/audit', "pdfkey": "product-metrix" },
    {
      name: 'PHI Comparision',
      icon: 'track_changes',
      path: '/impr-tracking-a-a', "pdfkey": "product-metrix"
    },
    // {
    //   name: 'Audit Data',
    //   icon: 'file_download',
    //   path: '/survey-data',
    //   "pdfkey": "product-metrix"
    // }
  ],
  Ideation: [
    { name: 'Ideas Hopper', icon: 'lightbulb', path: '/ideas-hopper', "pdfkey": "ideation" },
    { name: 'Simulation', icon: 'event_note', path: '/sim-planning', "pdfkey": "ideation",
      children: [
        {
          name: 'SIM Planning',
          icon: 'dashboard',
         path: '/sim-planning',
        },
        {
          name: 'Portfolio-Level View',
          icon: 'grid_on',
          path: '/sim-portfolio',
          pdfkey: 'ideation',
        },
        {
          name: 'Portfolio Gaps',
          icon: 'view_column',
          path: '/portfolio-gaps',
          pdfkey: 'ideation',
        },
        {
          name: 'AOP Investment Summary',
          icon: 'waterfall_chart',
          path: '/aop-investment-summary',
          pdfkey: 'ideation',
        },
        {
          name: 'Investment and Return Summary',
          icon: 'table_chart',
          path: '/investment-return-summary',
          pdfkey: 'ideation',
        },
        {
          name: 'Product Roadmap',
          icon: 'dashboard',
          path: '/product-roadmap',

        },
           ],
     },


    { name: 'AOP Planning', icon: 'assessment', path: '/aop-planning-2026', "pdfkey": "ideation",
      children: [
        {
          name: 'AOP 2026',
          icon: 'dashboard',
          path: '/aop-planning-2026',
          "pdfkey": "ideation"
        },
        {
          name: 'AOP 2027',
          icon: 'dashboard',
          path: '/aop-planning-2027',
          "pdfkey": "ideation"
        },
      ],
    },
    {name: ' Historical Audit Summary', icon: 'query_stats', path: '/user-history', "pdfkey": "ideation" },
  ],
  'Current Projects': [
    {
      name: 'Project List',
      icon: 'folder_open',
      path: '/project-list',
      "pdfkey": "current-projects",
      children: [
        {
          name: 'Clarity',
          icon: 'folder_open',
          path: '/project-list',
          "pdfkey": "current-projects"
        },
        {
          name: 'Wave',
          icon: 'waves',
          path: '/wave-project-list',
          "pdfkey": "current-projects"
        }
      ]
    },
    { name: 'AOP Management', icon: 'sync', path: '/aop-mgmnt', "pdfkey": "current-projects" },
    {
      name: 'Spend Analysis',
      icon: 'request_quote',
      path: 'spend-analysis-overall',
      "pdfkey": "current-projects",
      children: [
        // {
        //   name: 'Spend Analysis Summary',
        //   icon: 'dashboard',
        //   path: 'spend-analysis-overall',
        //    children: [
        {
          name: 'YTD spends from AOP dashboard',
          icon: 'dashboard',
          path: '/spend-analysis-overall',
          "pdfkey": "current-projects",
        },
        {
          name: 'Consolidated Project Spends from Clarity',
          icon: 'dashboard',
          path: '/spend-analysis-detailed',
          "pdfkey": "current-projects",
        },
        //   ]
        //    },
        {
          name: 'Spends analysis by PHI Parameters',
          icon: 'dashboard',
          path: '/spend-analysis-view',
          "pdfkey": "current-projects",
        }
      ],
    },
  ],
  'Product Improvement': [
    {
      name: 'Spend Effectiveness',
      icon: 'price_check',
      path: '/spend-effectiveness',
      children: [
        { name: 'Spend Effectiveness', icon: 'price_check', path: '/spend-effectiveness', "pdfkey": "product-improvement" },
        { name: 'Spend Allocation', icon: 'stacked_bar_chart', path: '/spend-allocation', "pdfkey": "product-improvement" },
      ],
      "pdfkey": "product-improvement"
    },
    {
      name: 'Improvement Tracking',
      icon: 'track_changes',
      path: '/impr-tracking-a-e',
      "pdfkey": "product-improvement",
      children: [
        { name: 'Improvement Tracking', icon: 'track_changes', path: '/impr-tracking-a-e', "pdfkey": "product-improvement" },
        { name: 'Set Future Expectations', icon: 'science', path: '/set-future-expectations', "pdfkey": "product-improvement" },
      ],
    },
  ],
    Settings: [
    {
      name: 'List of Survey',
      icon: 'settings',
      path: '/survey-settings',
      "pdfkey": "settings"
    },
  ],

};

export const TopBarConfig: any = {
  lastUpdated: {
    enabled: true,
    dynamicQuarterMenu: 'Product Health',
    staticText: 'June 2026',
    hiddenMenus: ['Product Roadmap'],
    hiddenRoutes: [
      '/product-roadmap',
      '/user-history',
      '/ideas-hopper',
      '/sim-planning',
      '/sim-portfolio',
      '/portfolio-gaps',
      '/aop-investment-summary',
      '/investment-return-summary',
      '/aop-planning',
      '/aop-planning-2026',
      '/aop-planning-2027',
      
    ],
  },
};
